import type { FCWithChildren } from "~/types/react"
import { AnalyticsEvent, trackEvent } from "~/utils/analytics/analytics.client"
import { publicConfig } from "~/utils/config"

import Link from "../Link"

export type ContributeLinkProps = {
  className?: string
  url?: string
}

export const ContributeLink: FCWithChildren<ContributeLinkProps> = ({
  url,
  ...otherProps
}) => {
  const contributeURL = url || publicConfig.links.openCollective.url

  return (
    <Link
      href={contributeURL}
      isExternal
      onClick={(e) => {
        e.preventDefault()
        trackEvent(AnalyticsEvent.CONTRIBUTE_BUTTON_CLICK, {
          callback: () => {
            window.location.assign(contributeURL)
          },
        })
      }}
      {...otherProps}
    />
  )
}
